/**
 * @file: 索赔类 引用的 SKU 项
 *
 * @author: FJJ
 * @history:
 * Date         Version Remarks
 * ============ ======= ======================================================
 * 2023/08/29      1.0     First version
 *
 *
 * Copyright 2022, all rights reserved. Essa.cn
 * */
import React  from "react";
import {symbolMoneyUtil} from '@utils/utils';
import Lang from "@components/Lang/Lang";
import "./sku.less"
/**
 * 状 标签
 * 状态；1：审核中，2：待赔付，3：已拒绝，4：撤销申请，5：已赔付 7:待客户处理
 * */
const SkuWrap = ({item={}}) => {
    return (<div className={"SkuWrap_itemLi flex-item"}>
        <div className={"skuPic"}>
            <img src={item.skuUrl+ "@!200"} className="img" alt={item.skuName} />
        </div>
        <div className={"ml_16 itemInfo"}>
            <div className="ellipsis-line3" title={item.skuName}>{item.skuName}</div>
            <div className={"black45"} title={item.skuNo}>{Lang({id:"ShangPinBianHao",default:"商品编号"})}<span className={"black66 ml_4"}>{item.skuNo}</span></div>
            <div className="mt_4 font-12"><span className={"fw_700 font_16 mr_2"}>
                    {/*{item.skuCapacity}{__getServerDictItem("unit_type." + item.skuUnit)}*/}
                {symbolMoneyUtil((item.price||0), item.currencySymbol)}
                </span>/<span className={"black66 ml_2"}>
                    {__getServerDictItem("unit_type." + item.skuUnit)}
                {/*{__getServerDictItem("prd_goods_out_box_unit." + item.spuOutBoxUnit)||'-'}*/}
                </span></div>
            {item.skuCount>1&&item.pcsPrice>0&&<div className="mt_4 font-12"><span className={"fw_700 font_16 mr_2"}>
                    {/*{item.skuCapacity}{__getServerDictItem("unit_type." + item.skuUnit)}*/}
                {symbolMoneyUtil(item.pcsPrice, item.currencySymbol)}
                </span>/<span className={"black66 ml_2"}>PCS</span></div>}
            <div className={"mt_8 black45"}>{__getServerLanguage("ZongJi")}
                <span className="ml_2">{item.actLoadQuantity}</span>
                <span className="ml_2">{__getServerDictItem("prd_goods_out_box_unit." + item.spuOutBoxUnit)||'-'}，</span>
                <span className="ml_4">{symbolMoneyUtil(item.totalPrice, item.currencySymbol)}</span>
            </div>
        </div>
    </div>)
}

export default SkuWrap;

